import { createFileRoute, Link } from "@tanstack/react-router";
import { useWishlist } from "@/hooks/storefront/use-wishlist";
import { useCart } from "@/hooks/storefront/use-cart";
import { formatPrice, productSlug } from "@/lib/format";
import { optimizeImage } from "@/lib/image";

export const Route = createFileRoute("/_authenticated/account/wishlist")({
  head: () => ({ meta: [
      { property: "og:url", content: "https://mrpanda.gr/account/wishlist" },{ title: "Τα αγαπημένα μου — MrPanda.gr" }] }),
  component: WishlistTab,
});

function WishlistTab() {
  const { items, remove } = useWishlist();
  const cart = useCart();
  return (
    <div className="rounded-2xl border border-border bg-card p-6 shadow-sm">
      <h2 className="mb-4 flex items-center gap-2 text-xl font-bold">💖 Τα αγαπημένα μου</h2>
      {items.length === 0 ? (
        <div className="rounded-xl bg-muted/50 p-10 text-center">
          <div className="mb-2 text-4xl">💔</div>
          <p className="text-sm text-muted-foreground">Δεν έχεις αγαπημένα προϊόντα ακόμη.</p>
          <Link to="/" className="mt-3 inline-block text-sm font-medium text-primary underline">Ανακάλυψε προϊόντα</Link>
        </div>
      ) : (
        <ul className="grid gap-3 sm:grid-cols-2">
          {items.map((it) => (
            <li key={it.productId} className="flex gap-3 rounded-xl border border-border p-3 transition hover:shadow-sm">
              <Link
                to="/p/$slug"
                params={{ slug: productSlug(it.name, it.psId, it.productId) }}
                className="h-20 w-20 shrink-0 overflow-hidden rounded-lg bg-muted"
              >
                {it.imageUrl ? (
                  <img src={optimizeImage(it.imageUrl, { width: 96 })} alt={it.name} width={96} height={96} loading="lazy" decoding="async" className="h-full w-full object-contain" />
                ) : (
                  <div className="grid h-full w-full place-items-center text-2xl">🐼</div>
                )}
              </Link>
              <div className="flex flex-1 flex-col">
                <Link
                  to="/p/$slug"
                  params={{ slug: productSlug(it.name, it.psId, it.productId) }}
                  className="line-clamp-2 text-sm font-medium hover:text-primary"
                >
                  {it.name}
                </Link>
                <div className="text-price font-bold">{formatPrice(it.price)}</div>
                <div className="mt-auto flex gap-2 text-xs">
                  <button
                    onClick={() => cart.add({ productId: it.productId, psId: it.psId, name: it.name, price: it.price, imageUrl: it.imageUrl })}
                    className="rounded-full bg-primary px-3 py-1.5 font-medium text-primary-foreground transition hover:bg-primary/90"
                  >
                    🛒 Καλάθι
                  </button>
                  <button
                    onClick={() => remove(it.productId)}
                    className="rounded-full border border-border px-3 py-1.5 transition hover:bg-muted"
                  >
                    Αφαίρεση
                  </button>
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
